import { useEffect } from 'react'
import ReactDOM from 'react-dom'

/**
 * MapOverlay component is a wrapper for google.maps.OverlayView
 */
const MapOverlay = ({ googleMaps, latLng, map, setCenter, children }) => {

  let container = document.createElement( 'div' )
  let firstDraw = true

  useEffect(() => {
    const overlay = new googleMaps.OverlayView()

    overlay.onAdd = () => {
      container.style.position = 'absolute'
      overlay.getPanes().floatPane.appendChild( container )
    }

    overlay.draw = () => {
      const projection = overlay.getProjection()
      const point = projection.fromLatLngToDivPixel( latLng )
      const width = container.offsetWidth
      const height = container.offsetHeight
      const left = ( point.x - width / 2 )
      const top = ( point.y - height )
      container.style.left = `${left}px`
      container.style.top = `${top}px`
      if ( firstDraw ) {
        const topCenter = ( point.y - height / 2 )
        const center = projection.fromDivPixelToLatLng( new googleMaps.Point( point.x, topCenter ))
        setCenter( center )
        firstDraw = false
      }
      // setCenter( center )
    }

    overlay.onRemove = () => {
      container.parentNode && container.parentNode.removeChild( container )
    }

    overlay.setMap( map )

  })

  return ReactDOM.createPortal( children, container )

}

export default MapOverlay
